import React, { useState } from 'react';
import { Button, FormHelperText, Input, Typography } from '@screentone/core';
import { useHistory } from 'react-router-dom';
import './PrintIdForm.styles.css';

export const PrintIdForm = () => {
  const history = useHistory();
  const [chartId, setChartId] = useState('');
  const [error, setError] = useState('');

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (chartId.length !== 24) setError('Please enter a valid chart ID');
        else history.push(`/wsj/print/chart/${chartId}`);
      }}
      className="print-view-form"
    >
      <Typography variant="header2">Please paste your WSJ Print chart ID</Typography>
      <Input
        type="text"
        name="chartId"
        error={!!error}
        onChange={(e) => {
          if (e.key === 'enter') {
            if (chartId.length !== 24) setError('Please enter a valid chart ID');
            history.push(`/wsj/print/chart/${chartId}`);
          } else {
            if (error) setError('');
            setChartId(e.target.value);
          }
        }}
      />
      <FormHelperText error>{error}</FormHelperText>
      <Button margin={{ vertical: 'md' }} primary>
        Submit
      </Button>
    </form>
  );
};
